import { OptionPricingFormula, ESBAmericanType } from '../services/greeks'

export const getPositionsData = (transactionData) => {
      const positions = [];
      const distinctOptionSymbols = getDistinctOptionSymbol(transactionData);
      distinctOptionSymbols.forEach(item => {
        const currentOption = item;
        const optionSymbolTransactions = transactionData.filter(item => item.OptionSymbol == currentOption);
        const openTrades = [];
        let qty = 0;
        let plClosed = 0;
  
        for (let i = 0; i < optionSymbolTransactions.length; i++) {
          let isClosingTrade = false;
          if ((qty > 0 && optionSymbolTransactions[i].Qty < 0) || (qty < 0 && optionSymbolTransactions[i].Qty > 0)) {
            isClosingTrade = true;
          }
          qty = qty + optionSymbolTransactions[i].Qty;
          if (!isClosingTrade) {
            addToOpenTrade(optionSymbolTransactions[i].Qty, optionSymbolTransactions[i].TradePrice, openTrades);
          }
          else {
            let qtyLeft = Math.abs(optionSymbolTransactions[i].Qty);
            for (let j = 0; j < openTrades.length; j++) {
              if (qtyLeft == 0 || openTrades[j].Qty == 0) {
                break;
              }
              var originalQty = Math.abs(openTrades[j].Qty);
              var qtyForCalc = openTrades[j].Qty;
              if (originalQty >= qtyLeft) {
                var signIndicator = 1;
                if (qtyForCalc < 1) {
                  signIndicator = -1;
                }
                openTrades[j].Qty = qtyForCalc - (qtyLeft * signIndicator);
                qtyForCalc = qtyLeft * signIndicator;
                qtyLeft = 0;
              }
              else {
                openTrades[j].Qty = 0;
                qtyLeft = qtyLeft - originalQty;
              }
              plClosed = plClosed + (optionSymbolTransactions[i].TradePrice * qtyForCalc * optionSymbolTransactions[i].Multiplier) - (openTrades[j].OpenPrice * qtyForCalc * optionSymbolTransactions[i].Multiplier)
            }
            if (qtyLeft > 0) {
              if (optionSymbolTransactions[i].Qty < 0) {
                qtyLeft = qtyLeft * -1;
              }
              addToOpenTrade(qtyLeft, optionSymbolTransactions[i].TradePrice, openTrades);
            }
          }
        }
  
        const newPosition = {};
  
        newPosition.Instrument = optionSymbolTransactions[0].StockSymbol;
        newPosition.OptionSymbol = optionSymbolTransactions[0].OptionSymbol;
        newPosition.marketPrice = optionSymbolTransactions[0].marketPrice;
        newPosition.IsClosed = true;
        let totalPrice = 0;
  
        let dates = [];
        let totalQty = 0;
        for (let i = 0; i < openTrades.length; i++) {
          totalPrice += (openTrades[i].Qty * openTrades[i].OpenPrice);
          totalQty += openTrades[i].Qty;
          dates.push(new Date(optionSymbolTransactions[i].TradeDate));
        }
        newPosition.Quantity = totalQty;
        newPosition.Price = optionSymbolTransactions[optionSymbolTransactions.length - 1].Mark;
        if (optionSymbolTransactions[optionSymbolTransactions.length - 1].TradeType === 2) {
          newPosition.IsStock = true;
        }
        else {
          newPosition.IsStock = false;
        }
  
        var sortedDates = dates.sort((a, b) => a - b);
        newPosition.OpenDate = sortedDates[0];
  
        if (totalQty == 0) {
          newPosition.CloseDate = sortedDates[sortedDates.length - 1];
          newPosition.AveragePrice = null;
        }
        else {
          newPosition.AveragePrice = totalPrice / totalQty;
          newPosition.CloseDate = null;
          newPosition.IsClosed = false;
        }
        newPosition.PlClosed = plClosed;
        newPosition.PlOpen = (optionSymbolTransactions[optionSymbolTransactions.length - 1].Mark * totalQty * optionSymbolTransactions[0].Multiplier) - (newPosition.AveragePrice * totalQty * optionSymbolTransactions[0].Multiplier);
        addDescription(newPosition, optionSymbolTransactions[0]);
        addGreeks(newPosition, optionSymbolTransactions[optionSymbolTransactions.length - 1]);
        positions.push(newPosition);
      });
      return positions;
}

const addGreeks = (position, transaction) => {
    position.Delta = '';
    position.Gamma = '';
    position.Theta = '';
    position.Vega = '';
    position.ImpliedVolatility = '';
    position.DeltaPosition = '';
    position.GammaPosition = '';
    position.ThetaPosition = '';
    position.VegaPosition = '';
    let expirationDate = new Date(transaction.ExpirationDate);
    let daysToExpire = Math.round((expirationDate - new Date()) / (1000 * 3600 * 24));
    let factor = 1;
    const expiredDate = expirationDate.setHours(0, 0, 0, 0);
    const currentTime = new Date();
    const pricingFormula = new OptionPricingFormula();
    if (expiredDate == new Date().setHours(0, 0, 0, 0)) {
        daysToExpire = 1;
        if (currentTime.getHours < 9) {
            factor = 1;
        }
        else {
            if (currentTime.getHours > 16) {
                daysToExpire = 0;
            }
            else {
                factor = 6.5 / (16 - currentTime.getHours());
            }
        }
    }
    else {
        if (currentTime.getHours() <= 16 && currentTime.getHours() >= 9) {
            daysToExpire = daysToExpire + ((currentTime.getHours() - 9.5) / 6.5);
        }
    }
    position.UnderlyingPrice = transaction.UnderlyingPrice;
    position.DaysToExpire = daysToExpire;
    position.TradeType = transaction.TradeType;
    position.Strike = transaction.Strike;
    position.TradeSide = transaction.TradeSide;
    position.Multiplier = transaction.Multiplier;
    position.Mark=transaction.Mark;
    position.ExpirationDate = transaction.ExpirationDate;
    if (transaction.TradeType == 1) {
        if (daysToExpire > 0 && transaction.UnderlyingPrice > 0 && transaction.Strike > 0) {
            position.ImpliedVolatility = pricingFormula.gImpliedVolatilityNR(false, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0.0025, 0, transaction.Mark);
            if (factor != 1 && factor != 0) {
                position.ImpliedVolatility = position.ImpliedVolatility * Math.sqrt(1 / factor);
            }
            position.Delta = pricingFormula.eBSAmericanApprox2002(ESBAmericanType.Delta, false, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0.025, 0, position.ImpliedVolatility, 0);
            position.Gamma = pricingFormula.eBSAmericanApprox2002(ESBAmericanType.Gamma, false, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0.025, 0, position.ImpliedVolatility, 0);
            position.Theta = pricingFormula.eBSAmericanApprox2002(ESBAmericanType.Theta, false, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0.025, 0, position.ImpliedVolatility, 0);
            position.Vega = pricingFormula.eBSAmericanApprox2002(ESBAmericanType.Vega, false, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0.025, 0, position.ImpliedVolatility, 0);
        }
    }
    if (transaction.TradeType == 0) {
        if (daysToExpire > 0 && transaction.UnderlyingPrice > 0 && transaction.Strike > 0) {
            var mark = transaction.Mark;
            if (transaction.UnderlyingPrice > transaction.Strike) {
                var val = transaction.UnderlyingPrice - transaction.Strike;
                if (val > transaction.Mark) {
                    mark = val + 0.01;
                }
            }
            position.ImpliedVolatility = pricingFormula.gImpliedVolatilityNR(true, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0.0025, 0, mark);
            if (factor != 1 && factor != 0) {
                position.ImpliedVolatility = position.ImpliedVolatility * Math.sqrt(1 / factor);
            }
            position.Delta = pricingFormula.eBSAmericanApprox2002(ESBAmericanType.Delta, true, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0, 0, position.ImpliedVolatility, 0);
            position.Gamma = pricingFormula.eBSAmericanApprox2002(ESBAmericanType.Gamma, true, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0.025, 0, position.ImpliedVolatility, 0);
            position.Theta = pricingFormula.eBSAmericanApprox2002(ESBAmericanType.Theta, true, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0.025, 0, position.ImpliedVolatility, 0);
            position.Vega = pricingFormula.eBSAmericanApprox2002(ESBAmericanType.Vega, true, transaction.UnderlyingPrice, transaction.Strike, daysToExpire / 365, 0.025, 0, position.ImpliedVolatility, 0);
        }
    }
    if (transaction.TradeType == 2) {
        position.Delta = 1;
    }
    position.DeltaPosition = position.Delta * position.Quantity * transaction.Multiplier;
    position.GammaPosition = position.Gamma * position.Quantity * transaction.Multiplier;
    position.ThetaPosition = position.Theta * position.Quantity * transaction.Multiplier;
    position.VegaPosition = position.Vega * position.Quantity * transaction.Multiplier;
}

const addDescription = (position,transaction) => {
    let tradeTypeName = '';
    let multiplier='';
    let tradeSideName='';

    if (position.Quantity>0){
        tradeSideName= 'Long ';
    }
    if (position.Quantity<0){
        tradeSideName=  'Short ';
    }
    position.InstrumentDescription = '';
    position.DaystoExpireDescription = '';
    let expirationDate = new Date(transaction.ExpirationDate);
    let daysToExpire = Math.round((expirationDate - new Date()) / (1000 * 3600 * 24));
    let months = [
      "Jan", "Feb", "Mar",
      "Apr", "May", "Jun", "Jul",
      "Aug", "Sep", "Oct",
      "Nov", "Dec"
    ];
    switch(transaction.TradeType) {
        case 0:
        case 1:
            if (transaction.TradeType==0){
                tradeTypeName="C";
            }
            else{
                tradeTypeName="P";
            }
            if (transaction.Multiplier==10){
                multiplier=" Mini";
            }
            if (transaction.Multiplier!=100){
                multiplier="M - " + transaction.Multiplier.toString();
            }
            position.InstrumentDescription = position.Quantity+' '+transaction.StockSymbol + ' ' + (expirationDate.getMonth() + 1) + '/' + expirationDate.getDate() + '/' + expirationDate.getFullYear() + ' - ' + transaction.Strike + ' ' + tradeTypeName + ' ' + multiplier;
            if (position.Quantity != 0) {

                if (daysToExpire < 0) {
                    position.DaystoExpireDescription = "Expired";
                }
                else {
                    if (daysToExpire == 0) {
                        position.DaystoExpireDescription = "Expires Today";
                    }
                    else {

                        if (daysToExpire == 1) {
                            position.DaystoExpireDescription = "1 Day";
                        }
                        else {
                            position.DaystoExpireDescription = daysToExpire.toString()+" Days";
                        }
                    }
                }
            }
            break;
        case 5:
            position.InstrumentDescription=transaction.StockSymbol+" Div";
            break;  
        default:
            position.InstrumentDescription = "";
            position.DaystoExpireDescription = "";
    } 
    
}

const addToOpenTrade = (openTradeQty, openTradePrice, openTrades) => {
    const openTrade = {};
    openTrade.Qty = openTradeQty;
    openTrade.OpenPrice = openTradePrice;
    //openTrade.Symbol = optionSymbolTransaction.OptionSymbol;
    openTrades.push(openTrade);
}

const getDistinctOptionSymbol = (tradeTransactions) => {
    const distinctOptionSymbols = [];
    tradeTransactions.forEach(value => {
      if (distinctOptionSymbols.indexOf(value.OptionSymbol) === -1) {
        distinctOptionSymbols.push(value.OptionSymbol);
      }
    })
    return distinctOptionSymbols;
}





// WEBPACK FOOTER //
// ./src/utils/tradeTransactions.js